import * as React from 'react';
export const optimismSvg = React.forwardRef(function optimismSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12Z',
      fill: '#FF0420',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.502 19.19c-.714 0-1.3-.169-1.756-.505-.45-.342-.675-.829-.675-1.459 0-.132.015-.294.045-.486.078-.433.189-.952.333-1.558.408-1.652 1.462-2.477 3.161-2.477.463 0 .877.078 1.243.234.366.15.655.378.865.684.21.3.315.66.315 1.081a3.2 3.2 0 0 1-.045.477 20.43 20.43 0 0 1-.324 1.559c-.21.822-.574 1.438-1.09 1.846-.516.402-1.207.603-2.072.603Zm.127-1.298c.336 0 .621-.099.855-.297.24-.198.411-.501.514-.91a21.89 21.89 0 0 0 .315-1.476c.024-.127.036-.256.036-.388 0-.546-.285-.82-.856-.82-.336 0-.624.1-.864.298-.235.198-.403.501-.505.91a19.59 19.59 0 0 0-.324 1.477c-.024.12-.036.246-.036.378 0 .552.288.828.865.828Zm3.818 1.207a.19.19 0 0 1-.154-.063.215.215 0 0 1-.027-.162l1.243-5.854a.258.258 0 0 1 .1-.162.275.275 0 0 1 .17-.063h2.396c.667 0 1.201.138 1.603.414.409.276.613.675.613 1.198 0 .15-.018.306-.054.468-.15.69-.453 1.201-.91 1.531-.45.33-1.069.496-1.855.496h-1.216l-.414 1.972a.258.258 0 0 1-.1.162.275.275 0 0 1-.17.063h-1.226Zm3.188-3.44c.252 0 .471-.07.657-.207a.973.973 0 0 0 .379-.595c.018-.102.027-.192.027-.27 0-.174-.051-.306-.154-.396-.102-.096-.276-.144-.522-.144h-1.08l-.343 1.612h1.036Z',
      fill: '#fff',
    }),
  );
});
optimismSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var optimism = {
  category: 'brand',
  colorable: false,
  name: 'optimism',
  svg: optimismSvg,
};
